import styled from 'react-emotion';

const styleProps = [
  'color',
  'hoverColor',
];

const options = {
  shouldForwardProp: p => !styleProps.includes(p),
};

const StyledButton = styled('button', options)((props) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: 26,
  border: 0,
  background: 'none',
  padding: 0,
  cursor: 'pointer',
  '[data-label]': {
    color: props.color,
    textTransform: 'uppercase',
    width: 24,
    height: 24,
    lineHeight: '24px',
  },
  '[data-icon]': {
    fill: props.color,
    width: 20,
    height: 20,
  },
  ':hover': {
    '[data-label]': {
      color: props.hoverColor,
    },
    '[data-icon]': {
      fill: props.hoverColor,
    },
  },
  '&[data-active]': {
    '[data-icon]': {
      transform: 'rotate(180deg)',
    },
  },
}));

export default StyledButton;


// WEBPACK FOOTER //
// ./src/js/widgets/Header/LanguageSelector/StyledButton.js